export const getHttpErrorMsg = (statusCode: number) => {
  if (statusCode >= 400 && statusCode < 500) {
    return `Client side error occured (${statusCode})`;
  } else {
    return `Server side error occured (${statusCode})`;
  }
};
